import React from "react";
import { useDropzone } from "react-dropzone";

/**
 *
 * @param {Function} onDrop - Callback function when file is dropped
 * @param {string} accept - File type to accept e.g. "image/*", "video/*", ".pdf", ".csv, .zip" etc.
 * @param {React.ReactNode} children - React children to render as Input component
 * @returns {React.ReactNode} - DropZone component
 */
const DropZone = ({ onDrop, accept, children }) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept,
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {children({
        isDragActive,
        isDragAccept,
        isDragReject,
      })}
    </div>
  );
};

export default DropZone;
